import a from "../hooks/graphql/useGetFrontendConfig.js";
import { PRELOAD_KEY as r } from "../../temp-lib/constants/preloadKey.js";
import { usePreloadContext as C } from "../../temp-lib/contexts/share/PreloadContext.js";
import { createStrictContext as u } from "../../temp-lib/util/context/createStrictContext.js";
import * as l from "ramda";
import { useState as p, useCallback as d } from "react";
import g from "use-async-effect";
import { jsx as F } from "react/jsx-runtime";
const [N, y] = u("FrontendConfig"), D = (e) => {
  const {
    children: i
  } = e, [o, f] = p(null), {
    preloadValue: t
  } = C(), {
    fetch: n
  } = a(), s = d(async () => l.isNotNil(o) ? o : t(r.FRONTEND_CONFIG, n), [o, n, t]);
  return g(async (c) => {
    const m = await t(r.FRONTEND_CONFIG, n);
    c() && f(m);
  }, []), /* @__PURE__ */ F(N, {
    value: {
      config: o,
      waitConfig: s
    },
    children: i
  });
};
export {
  D as FrontendConfigProvider,
  y as useFrontendConfigContext
};
//# sourceMappingURL=FrontendConfigContext.js.map
